import { format } from 'owa-localize';
import { localizedFormatter } from './localizedFormatter';
import { getLocalizedString } from 'owa-datetime-formatters-core';
import isOneSpecifierBeforeTheOther from './isOneSpecifierBeforeTheOther';
import type { OwaDate, GlobalCalendarLocale } from 'owa-datetime';

/**
 * This function produces a format similar to getMonthDayFormat but ignores user settings
 * and hardcodes an abbreviated month and the day without leading zeros.
 * This should be used in places where space is at a premium.
 * Common output is 'MMM d' or 'd MMM'.
 */
export function getShortMonthDayFormat(dateFormat: string, _timeFormat: string): string {
    const dayFirst = isOneSpecifierBeforeTheOther(dateFormat, 'd', 'M');
    const formatString = dayFirst
        ? getLocalizedString('monthDayFormatDayFirst')
        : getLocalizedString('monthDayFormatMonthFirst');
    return format(formatString, getLocalizedString('MMM'), getLocalizedString('d'));
}

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    localizedFormatter(getShortMonthDayFormat);
export default defaultExport;
